import styled from 'styled-components';

import { ptr } from '#styles.utils';

export const FormikContainer = styled.div`
  .create-restaurant__submit {
    min-width: ${ptr(220)};
  }
`;
